import React from 'react';
import { useTranslation } from 'react-i18next';
import { SubjectTypes } from '../../../../../../types/RiskAnalaysis';
import IllustrationIconSelector from '../../../../../common/src/components/IllustrationIconSelector';
import { useLouiseSelector } from '../../../../../sales-conversation/src/store/redux/store';
import IllustrationCheckboxButton from '../../input/IllustrationCheckboxButton';
import { Box, useCheckboxGroup } from '@wegroup/design-system';

interface Props {
  subjects: SubjectTypes[];
  handleChange: (values: SubjectTypes[]) => void;
}

const SubjectSelectionCheckboxes: React.FC<React.PropsWithChildren<Props>> = ({
  subjects,
  handleChange,
}) => {
  const { t } = useTranslation();
  const selectedValues = useLouiseSelector(
    (state) => state.riskAnalysisSelection.subjects,
  );

  const { getCheckboxProps } = useCheckboxGroup({
    value: selectedValues,
    onChange: handleChange,
  });

  // Map correct illustration to subject key
  const getIllustrationType = (subject: SubjectTypes): string =>
    ({
      [SubjectTypes.MOBILITY]: 'mobility',
      [SubjectTypes.HOME_AND_FAMILY]: 'house',
      [SubjectTypes.TRAVEL_AND_LEISURE]: 'travel',
      [SubjectTypes.HEALTH]: 'health',
      [SubjectTypes.HOBBIES_AND_INTERESTS]: 'hobbies_and_interests',
      [SubjectTypes.LIFE_AND_FUTURE]: 'life_and_future',
      [SubjectTypes.LEGAL]: 'legal',
    }[subject]);

  return (
    <>
      {subjects.map((subject) => (
        <Box key={subject} flexShrink={0}>
          <IllustrationCheckboxButton
            useCheckboxProps={getCheckboxProps({
              value: subject,
            })}
            Illustration={
              <IllustrationIconSelector
                active={selectedValues.includes(subject)}
                type={getIllustrationType(subject)}
              />
            }
            dataTestId={`RISK-ANALYSIS_SUBJECT-SELECT_CHECKBOX-${subject}`}
          >
            <Box textAlign="center">
              <span>{t(`SUBJECT-TYPES-${subject}`)}</span>
            </Box>
          </IllustrationCheckboxButton>
        </Box>
      ))}
    </>
  );
};

export default SubjectSelectionCheckboxes;
